export interface TransformationRow {
  n: string;
  title: string;
  before: string;
  after: string;
}

export const transformationRows: TransformationRow[] = [
  {
    n: '1/4',
    title: 'Planificación',
    before: 'Noches de domingo buscando ejercicios sueltos en YouTube que no terminan de encajar con tu categoría ni con tu pista.',
    after: 'Sesiones organizadas para preparar tu próximo entrenamiento.'
  },
  {
    n: '2/4',
    title: 'Seguridad',
    before: 'Inseguridad al llegar a la pista sin saber si lo que has preparado es lo correcto para el nivel de tus jugadores. Improviso sobre la marcha.',
    after: 'Confianza total. Ejercicios con correcciones clave, variantes y progresiones claras semana a semana. K1 y K2 organizados.'
  },
  {
    n: '3/4',
    title: 'Variedad',
    before: 'Los mismos 8 ejercicios de siempre que tus jugadores ya hacen en piloto automático (toques contra pared, recepciones básicas).',
    after: 'Variantes y progresiones para ajustar el reto al equipo.'
  },
  {
    n: '4/4',
    title: 'Energía',
    before: 'Llegas a la pista mentalmente agotado de haber organizado todo desde cero mientras intentabas cenar.',
    after: 'Menos tiempo planificando y más energía para observar, corregir y dirigir a tus jugadores durante el entrenamiento.'
  }
];

export interface TransformationFooterStat {
  value: string;
  label: string;
}

export const transformationFooterStats: TransformationFooterStat[] = [
  { value: '40 semanas', label: 'Ruta de temporada' },
  { value: '2 clics', label: 'Para cada sesión lista' },
  { value: '100%', label: 'Profesional' }
];
